import React from "react";
import styles from "../styles/group-info.module.css";

function GroupInfo() {
  return (
    <section className={styles.groupInfo} id="about">
      <div className={styles.aboutContainer}>
        <h2>About Us</h2>
        <p>
          The 21st Bournemouth Scout Group is a welcoming place for young people to learn new skills, 
          make friends, and enjoy outdoor adventures. 
          We run sections for Squirrels, Beavers, Cubs, and Scouts, 
          each offering age-appropriate activities that help build confidence and teamwork.
        </p>
      </div>
      
      <div className={styles.meetContainer}>
        <div className={styles.customShapeDividerTop}>
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className={styles.shapeFill}></path>
          </svg>
        </div>
        <h2>Where We Meet</h2>
        <p>
          Our headquarters is located at the 21st Bournemouth Scout Hut, Baker Rd, Bournemouth BH11 9JD, just round the corner from Butchers Coppice Activity Center, which we use for many of our outdoor activities.
        </p>
      </div>
    </section>
  );
}

export default GroupInfo;
